export class FreemiumParams {
  jobTitleSelectedList: any[];
  jobTitleStatus: string;

  pastJobTitleSelectedList: any[];

  locationSelectedList: any[];

  skillsSelectedList: any[];

  companySelectedList: any[];
  companyStatus: string;

  companySizeSelectedList: any[];
  companysize: any;
  isCompanySizeSelected: boolean;

  industrySelectedList: any[];
  industryStatus: string;

  functionSelectedList: any[];
  // functionsInput?: any; Logic for this should be handled in filter component

  seniorityLevelSelectedList: any[];
  seniority: any;

  // yearsofexperienceFrom?: any; Logic for this should be handled in filter component
  yearsofexperienceTo?: any;
  yearsofexperienceFrom?: any;
  filterAppliedOnYearsOfExperience: boolean;
  yearsofexperience: any;

  currentfromyearsofexperience: any;
  currenttoyearsofexperience: any;
  filterAppliedOnCurrentYearsOfExperience: boolean;

  gender: any;
  isGenderSelected: boolean;
  isFemaleMatrixSelected: boolean;
  isMaleMatrixSelected: boolean;

  educationSelectedList: any[];

  schoolSelectedList: any[];
  schoolLocationSelectedList: any[]

  fieldOfStudySelectedList: any[];

  filterLikelyToMoveIn: any;
  candidateslikelytomove: any;
  isLikelyToMoveInFilterSelected: boolean;

  isChangedJobsSelected: boolean;
  changedJobStatus: any;
  changedJobStartDuration: number;
  changedJobEndDuration: number;

  talentdiscoveryhistoryid: string;

  continentstobeincluded: any[];
  searchHistoryRegion: string | null;

  keywordSelectedList: any[];
  booleanquery?: string;
  fullnameSelectedList: any[];
  winningtalent: any;

  distancefromselectedlocationsmeasurementunit: string;
  distancefromselectedlocations: number

  profilehighlights: string[];
  job_description_keys: any
}

export type FreemiumJdData = {
  status: string;
  jdData: {
      "Job Title": string;
      "Suggested job Title": string[];
      "Mandatory Skills"?: string[];
      "Preferred Skills": string[];
      Tools: string[];
      "Years of experience": {
          "minimum experience": number;
          "maximum experience": number;
      };
      "Relevant Year of experience": {
          "minimum experience": number;
          "maximum experience": number;
      };
      Industry: string[];
      Location: {
          city: string,
          continent: string,
          country: string,
          state: string
      };
      "Target Company": string[];
      Degree: string[];
      mandatoryDegree?: string[];
      "Field of study": string[];
      School: string[];
  };
};

export class PersonData  {
  candidateList: any[];
  totalCandidatesCount: number;
  talentdiscoveryhistoryid: string;
  totalresultscount: number;
  booleanquery: string;

  constructor() {
    this.candidateList = [];
    this.totalCandidatesCount = 0;
    this.talentdiscoveryhistoryid = "";
    this.totalresultscount = 0;
    this.booleanquery = "";
  }
}

export class FreemiumFilter {
  jobtitles: string [];
  skills: string [];
  locations: string [];
}
